const UNIQUE = {
  mid: function () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    const mmid = `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
    return mmid
  },
  fileid: function () {
    const fileid = (new Date().valueOf())
    return fileid
  },
  isUuid (str) {
    const pattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    return pattern.test(str)
  },
  uniqueId8: () => { // 타임스탬프+랜덤 조합 8자리
    const timestamp = Date.now().toString() // 현재 타임스탬프 (밀리초)
    const random = Math.random().toString(36).substring(2, 10) // 랜덤 문자열 (소문자+숫자)
    return timestamp.slice(-4) + random.slice(0, 4) // 8자리 조합 (타임스탬프 4 + 랜덤 4)
  }
}

export default UNIQUE
